/* unplugin-vue-components disabled */import script from "./ReportResult.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportResult.vue?vue&type=script&setup=true&lang=ts"

import "./ReportResult.vue?vue&type=style&index=0&id=7c132dce&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c132dce"]])

export default __exports__